export enum JobStatus {
	Running,
	Paused,
	Succeeded,
	Failed,
	PartiallyDone,
}
